import { DateTimeUtils, useAppNowUtc, useTimezone } from '@mews/framework';

export const useIsPastDate = (selectedDate: string) => {
    const today = useAppNowUtc();
    const timezone = useTimezone();

    const todayWithoutTime = DateTimeUtils.dateTimeUtcStringToDateISOString(today.value, timezone);

    if (!todayWithoutTime || !selectedDate) {
        return false;
    }

    return selectedDate < todayWithoutTime;
};
